export default {"src":"/_next/static/media/accept_star.9111b129.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};